import type {SocketContext} from './subscriptionTypes';

/**
 * Nulls out a socket's handlers and cancels its keep-alive timer so any late
 * event from it becomes a no-op. Idempotent — safe to call from cleanup, from
 * the next `openSocket()`, or from the auth-error branch.
 */
export const detachSocket = (ctx: SocketContext) => {
  clearTimeout(ctx.keepAliveTimeout);
  ctx.socket.onopen = null;
  ctx.socket.onmessage = null;
  ctx.socket.onclose = null;
  ctx.socket.onerror = null;
};
